import * as actionTypes from '../actions';

const initialState = {
    errorState: {
        hasError: false,
        errorMessage: ""
    },
    isAuthorized: false,
    byPassIntroduction: false,
    isLoading: false,
    companyName: "",
    indexProtector: null
};

const globalStateReducer = (state = initialState, action) => {

    let newState = null;

    if (action.type === actionTypes.SET_BYPASS_INTRODUCTION) {
        newState = Object.assign({}, state);
        newState.byPassIntroduction = action.data;
        return newState;
    }

    if (action.type === actionTypes.SET_ERROR_STATE) {
        newState = Object.assign({}, state);
        newState.errorState = {
            hasError: true,
            errorMessage: action.errorMessage
        };
        return newState;
    }

    if (action.type === actionTypes.CLEAR_ERROR_STATE) {
        newState = Object.assign({}, state);
        newState.errorState = {
            hasError: false,
            errorMessage: ""
        };
        newState.isLoading = false;
        return newState;
    }

    if (action.type === actionTypes.SET_LOADING) {
        newState = Object.assign({}, state);
        newState.isLoading = true;
        return newState;
    }

    if (action.type === actionTypes.CLEAR_LOADING) {
        newState = Object.assign({}, state);
        newState.isLoading = false;
        return newState;
    }

    if (action.type === actionTypes.SET_AUTHORIZED) {
        return {
            ...state,
            isAuthorized: true
        }
    }

    if (action.type === actionTypes.SET_COMPANY_NAME) {
        return {
            ...state,
            companyName: action.value
        }
    }

    if (action.type === actionTypes.SET_SELECTED_INDEX_PROTECTOR) {
        return {
            ...state,
            indexProtector: action.value
        }
    }

    return state;
};

export default globalStateReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/globalState.js